import { useLang } from '../LangContext';
import translations from '../i18n';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;

export function AboutSection() {
  const { lang } = useLang();
  const t = translations[lang];
  // IT: testo da content.json; EN: testo da i18n.js
  const aboutText = (lang === 'en' && t.about.text)
    ? t.about.text
    : content.about.text;

  return (
    <section id="about-bottom" style={{ padding: '120px 40px', background: '#ED164E' }}>
      <h2 className="section-title reveal" style={{ color: 'var(--white)' }}>{t.about.title}</h2>
      <div style={{ maxWidth: '760px', margin: '0 auto' }}>
        {aboutText.split('\n\n').map((p, i) => (
          <p key={i} className={`reveal delay-${i+1}`} style={{ fontFamily: 'var(--font-body)', fontSize: 'clamp(1rem,1.5vw,1.15rem)', lineHeight: 1.9, color: 'rgba(255,255,255,0.9)', marginBottom: '24px' }}>{p}</p>
        ))}
      </div>
    </section>
  );
}

export function Footer() {
  const { lang } = useLang();
  const t = translations[lang];
  const { footer } = content;
  const nav = translations[lang].nav;
  const partner = content.partner;

  return (
    <footer style={{ background: '#080808', color: 'var(--white)', padding: '72px 40px 32px', borderTop: '1px solid rgba(229,0,60,0.2)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: '48px', marginBottom: '56px' }}>
        <div>
          <img src={`${pub}/loghi-sx-footer.svg`} alt="RUDE" style={{ height: '110px', width: 'auto' }} />
        </div>
        <div>
          <p style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '10px', letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--gray-mid)', marginBottom: '16px' }}>{t.footer.nav}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {nav.map((item, i) => (
              <a key={i} href={item.href} style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(255,255,255,0.5)', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--red)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >{item.label}</a>
            ))}
          </div>
        </div>
        <div>
          <p style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '10px', letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--gray-mid)', marginBottom: '16px' }}>{t.footer.partner}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
            {partner.map((p, i) => {
              const hasUrl = p.url && p.url.trim() !== '';
              const Tag = hasUrl ? 'a' : 'span';
              return <Tag key={i} href={hasUrl ? p.url : undefined} target={hasUrl ? '_blank' : undefined} rel={hasUrl ? 'noopener noreferrer' : undefined}
                style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(255,255,255,0.4)', transition: 'color 0.2s', display: 'block' }}
                onMouseEnter={e => e.target.style.color = 'var(--red)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}
              >{p.name}</Tag>;
            })}
          </div>
        </div>
        <div>
          <p style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '10px', letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--gray-mid)', marginBottom: '16px' }}>{t.footer.contact}</p>
          <a href={`mailto:${footer.contact}`} style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '24px' }}>{footer.contact}</a>
          <p style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '10px', letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--gray-mid)', marginBottom: '10px' }}>{t.footer.position}</p>
          <a href={footer.mapsUrl} target="_blank" rel="noopener noreferrer"
            style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'flex', alignItems: 'flex-start', gap: '6px', lineHeight: 1.5, transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--red)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}
          ><span>📍</span><span>{footer.mapsLabel}</span></a>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <span style={{ fontFamily: 'var(--font-body)', fontSize: '10px', color: 'rgba(255,255,255,0.2)' }}>{t.footer.copyright}</span>
        <a href="/privacy" style={{ fontFamily: 'var(--font-body)', fontSize: '10px', color: 'rgba(255,255,255,0.3)', transition: 'color 0.2s' }}
          onMouseEnter={e => e.target.style.color = 'var(--red)'}
          onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.3)'}
        >{t.footer.privacy}</a>
        <span style={{ fontFamily: 'var(--font-body)', fontSize: '10px', color: 'rgba(255,255,255,0.1)' }}>{t.footer.claim}</span>
      </div>
    </footer>
  );
}
